/* @ngInject */
const ownerButtons = (
  icons,
  ownerGo,
  ownerAsk
) => {
  const self = {}

  self.search = {
    icon: icons.search,
    action: ownerGo.consult,
    display: _nature => _nature === 'tables',
  }

  self.edit = {
    icon: icons.edit,
    action: ownerGo.edit,
    display: () => true,
  }

  self.delete = {
    icon: icons.delete,
    action: ownerAsk.delete,
    display: _nature => _nature === 'action',
    class: _railway => 'retour',
  }

  return self
}
export default ownerButtons



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/owners/owner/resources/buttons.resource.js